import { useDetectChannelId } from '@/features/Channels/hooks/useDetectChannelId';
import { useFetchChannel } from '@/features/Channels/hooks/useFetchChannel';
import { useFetchQueryParams } from '@/hooks/useFetchQueryParams';

import { useIsCommentsFeed } from './useIsCommentsFeed';

export const useGetTrackingInfo = () => {
  const { channelId } = useDetectChannelId();
  const { channel } = useFetchChannel(channelId);
  const { isGlobalComments } = useIsCommentsFeed();

  const { category_tab } = useFetchQueryParams();

  return {
    tab_name: isGlobalComments ? 'global_comments' : category_tab,
    feed_name: channel?.name,
  };
};
